import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Trans, useTranslation } from "react-i18next"

export interface ModalOcrUnverifiedProviderProps {
  isOpen: boolean
  close: () => void
  firstParagraphValues: object
}

export const ModalOcrUnverifiedProvider = ({
  isOpen = false,
  close,
  firstParagraphValues,
}: ModalOcrUnverifiedProviderProps) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-128 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Continuar'
          className='tw-px-4 tw-pb-1 tw-mt-3'
        >
          <ButtonPrimeReact
            label={`${t("importar.ocr.errorModal.continueLabel")}`}
            className='tw-w-full tw-h-12 !tw-bg-primary tw-text-simple-10'
            onClick={close}
          />
        </div>
      }
    >
      <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
        <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
          <FontAwesomeIcon
            icon={["fal", "exclamation-triangle"]}
            className='tw-w-8 tw-h-8 tw-text-danger'
          />
        </div>
      </div>
      <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
        {t("importar.ocr.errorModal.title")}
      </div>
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-px-4'>
        <p className='tw-mb-6'>
          <Trans
            i18nKey='importar.ocr.errorModal.firstParagraph'
            values={firstParagraphValues}
            components={[
              <span
                className='tw-font-medium tw-contents'
                key='0'
              />,
            ]}
          />
        </p>
        <p>
          <Trans
            i18nKey='importar.ocr.errorModal.secondParagraph'
            components={[
              <span
                className='tw-font-medium tw-contents'
                key='0'
              />,
            ]}
          />
        </p>
      </div>
    </PrimeReactModal>
  )
}
